var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[
        _vm.needClass === false? '': 'cp btn',
        _vm.themes? 'is-'+ _vm.themes: 'is-major',
        _vm.icon? 'icon-font '+ _vm.icon: '',
        _vm.text === '' && _vm.icon? 'icon-font-only': '',
        _vm.extendClass? _vm.extendClass: '' ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.click($event)},"mouseenter":function($event){$event.preventDefault();$event.stopPropagation();return _vm.mouseenter($event)}}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }